import { render, staticRenderFns } from "./ApkList.vue?vue&type=template&id=387fad35&scoped=true"
import script from "./ApkList.vue?vue&type=script&lang=js"
export * from "./ApkList.vue?vue&type=script&lang=js"
import style0 from "./ApkList.vue?vue&type=style&index=0&id=387fad35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387fad35",
  null
  
)

export default component.exports